import EventCard from "../../../../../ReusableComponent/EventCard";

const exams = [
  {
    category: "exam",
    title: "TCS CodeVita",
    date: "March 15, 2024",
    time: "10:00 AM (6 hours)",
    participants: "50,000",
    prize: "₹1,00,000 Prize Pool",
  },
  {
    category: "exam",
    title: "Google Code Jam",
    date: "April 2, 2024",
    time: "2:30 PM (2.5 hours)",
    participants: "25,000",
    prize: "$15,000 Prize Pool",
  },
  {
    category: "exam",
    title: "Microsoft Imagine Cup",
    date: "April 20, 2024",
    time: "11:00 AM (4 hours)",
    participants: "15,000",
    prize: "$10,000 Prize Pool",
  },
];

const UpcomingExamSection = () => {
  return (
    <section className="row mx-0 py-5 d-flex justify-content-center align-items-center">
      <div className="col-md-11 col-12">
        <div className="row mx-0 d-flex justify-content-center align-items-center">
          <div className="col-12 text-center mb-4">
            <h4 className="text-light fw-bold mb-4">Upcoming Exams</h4>
          </div>
          {exams.map((exam, index) => (
            <EventCard key={index} {...exam} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default UpcomingExamSection;
